import { connect } from 'react-redux'
import ResultsSection from 'components/search/results-item/ResultsSection'
import { setSignUpModalIsOpen } from 'redux/actions'

const mapStateToProps = state => ({
  searchType: state.search.searchType
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ResultsSection)
